import { environment } from "~/src/environments/environment";

export const MatSnackBarMessages = {
    ErrorMessage1: "Select a shape to Add",
    ErrorMessage2: "INVALID JOIN",
    ErrorMessage3: "INVALID POINT OF JOIN",
    ErrorMessage4: "Invalid Point Of Generation Shape Outside Canvas",
    ErrorMessage5: "Sorry, the selected grid is currently unavailable",
    ErrorMessageToPlaceCurved: "Cannot place on Curved Surface",
    MESH_LIMIT_REACHED: `You have reached the limit of ${environment.MAX_MESHES} meshes`,
    ErrorMessage6: "Not enough space to paste the selection.",
    ErrorMessage7: "No valid drop location found!",
    ErrorMessageForDrop: "There is no available space, or your shapes are colliding with other objects.",
    CollisionDetected: "Cannot paste here due to collision. Try another grid or make sure there's enough space.",
};
